import { ISearchable } from './Searchable.itf'

/**
* @typedef  ProduitLSConstructor
* @type {object}
* @property {string} nom - the nom value
* @property {Object} idProduitLS - the idProduitLS value

* */
export class ProduitLS extends ISearchable {
  /**
   * Creates an instance of ProduitLS.
   * @memberof ProduitLS
   * */
  constructor(object) {
    super()
    this.idCode = object.idCode
    this.idPoisson = object.idPoisson
    this.idTaille = object.idTaille
    this.idDenomination = object.idDenomination
    this.idConditionnement = object.idConditionnement
    this.idOrigine = object.idOrigine
    this.idQualite = object.idQualite
    this.idLabel = object.idLabel
    this.idPreparation = object.idPreparation
    this.idProduitTransforme = object.idProduitTransforme
    this.idCodeMagasin = object.idCodeMagasin
    this.plu = object.plu
    this.ean = object.ean
    this.idProduitLS = object.idProduitLS

    if (object.nom) {
      this.nom = object.nom
    }
  }

  formatToDisplay() {
    this.nom = `${this.nom}`
    this.lineClassName = 'lsLine'
    this.boxClassName = 'lsBox'
    this.displayType = `PLU : ${this.plu} - Produit LS`
    this.raccourci = `${this.nom}`
    this.created = true
    return this
  }

  formatToCreate() {
    this.formatToDisplay()
    this.created = false
    this.lineClassName = 'create-lsLine'
    return this
  }

  getNameAttribute() {
    return 'nom'
  }

  getIdAttribute() {
    return 'idProduitLS'
  }

  getRaccourciAttribute() {
    return 'raccourci'
  }
}
